/**
 * Garde d’accès des routes de jeu (cahier des charges : un compte dès l’entrée).
 *
 * Trois états, et aucun autre :
 * - `inconnu` : la restauration de session est en cours → indicateur de chargement, jamais une
 *   redirection prématurée qui ferait clignoter l’écran de connexion ;
 * - `anonyme` : redirection vers `/connexion` en mémorisant l’adresse demandée, pour y revenir
 *   après connexion — sauf pour l’accueil `/` : un visiteur sans compte qui arrive à la racine du
 *   site découvre d’abord le jeu (`/decouvrir`), d’où il peut créer un compte ou se connecter ;
 * - `connecte` : l’écran demandé est rendu.
 */
import { Navigate, useLocation } from 'react-router-dom';

import { useSessionStore } from '../api';
import { Chargement } from '../ui/Chargement';

import type { ReactNode } from 'react';

export interface ProprietesRouteProtegee {
  readonly children: ReactNode;
}

export function RouteProtegee({ children }: ProprietesRouteProtegee) {
  const statut = useSessionStore((etat) => etat.statut);
  const location = useLocation();

  if (statut === 'inconnu') {
    return (
      <div className="ecran ecran--centree">
        <Chargement />
      </div>
    );
  }

  if (statut === 'anonyme') {
    if (location.pathname === '/') {
      return <Navigate to="/decouvrir" replace />;
    }
    return (
      <Navigate
        to="/connexion"
        replace
        state={{ depuis: `${location.pathname}${location.search}` }}
      />
    );
  }

  return <>{children}</>;
}
